<template>
  <div class="education">
    <h3>Education</h3>
    <div class="content">
      <div class="university">
        <a href="https://www.usc.edu/" target="_blank">University of Southern California</a>
        <div class="duration">2012 &mdash; 2014</div>
      </div>
      <div class="college">Master of Science in Computer Science</a></div>
    </div>
    <div class="content">
      <div class="university">
        <a href="http://www.vit.ac.in/" target="_blank">VIT University</a>
        <div class="duration">2008 &mdash; 2012</div>
      </div>
      <div class="college">Bachelor of Technology in Computer Science & Eng.</a></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'education',
  };
</script>


// WEBPACK FOOTER //
// Education.vue?2a774437